import { helper } from '@ember/component/helper';

/**
 * Whether given params are explicitly false or 'false'
 * Note: returns false for other falsy values (e.g. undefined, null, 0)
 * @param {*[]} params
 * @return {boolean}
 */
export default helper(function isFalseHelper(params) {
  return params.every(v => v === false || v === 'false');
});
